import { render } from "./BranchDepartmentCreateUpdateModel.vue?vue&type=template&id=5a834885"
import script from "./BranchDepartmentCreateUpdateModel.vue?vue&type=script&lang=js"
export * from "./BranchDepartmentCreateUpdateModel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__